import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Destination } from '../../objects/destination';
import { Storefront } from './storefront.service';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class DestinationService
  extends BaseService {
  private destinationMapper = (destination: any) => ({
    ...destination,
    lat: destination.lat !== null ? +(destination.lat) : null,
    lng: destination.lng !== null ? +(destination.lng) : null
  } as Destination);

  get(slugOrId: number | string): Observable<Destination> {
    const url = `${this.baseUrl}/public/destinations/${slugOrId}`;
    return this.http
      .get<Destination>(url)
      .pipe(map(this.destinationMapper));
  }

  getAll(storefront: Storefront | null): Observable<Destination[]> {
    const url = `${this.baseUrl}/public/destinations`;

    const params = {
      ['delivery']: 'false',
    } as any;

    if (!!storefront) {
      params.storefront_slug = storefront.slug;
    } else {
      params.owner_group_slug = this.hostname;
    }

    return this
      .getPagedRequest({ url, params })
      .pipe(
        map(destinations => {
          const uniqueDestinations = destinations
            .filter((dest: any) => dest.destination_type !== 'delivery' && !dest.attendants_only)
            .map(this.destinationMapper)
            .reduce((acc, current) => {
              const x = acc.find(item => item.id === current.id);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, [] as Destination[]);
  
          return uniqueDestinations.sort((a, b) => a.name.localeCompare(b.name));
        })
      );
  }

  createInstance = (values: Destination): Destination => values;
}
